import { Link } from 'react-router-dom';
import gif from '../assets/landingpage.gif';

function HeroSection() {
  return (
    <section className="relative min-h-screen bg-[#0a0a1a] flex items-center overflow-hidden pt-20">
      {/* Background effects */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-72 h-72 bg-violet-600/20 rounded-full blur-3xl animate-pulse"></div>
        <div
          className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-indigo-500/15 rounded-full blur-3xl animate-pulse"
          style={{ animationDelay: '1s' }}
        ></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-violet-900/10 rounded-full blur-3xl"></div>
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage:
              'linear-gradient(#ffffff 1px, transparent 1px), linear-gradient(90deg, #ffffff 1px, transparent 1px)',
            backgroundSize: '60px 60px',
          }}
        ></div>
      </div>

      {/* Container */}
      <div className="container mx-auto px-2 py-16 w-full relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Left Content */}
          <div className="flex-1">
            <div className="inline-flex items-center gap-2 bg-violet-500/10 border border-violet-500/20 text-violet-300 text-xs font-semibold px-4 py-2 rounded-full mb-6 backdrop-blur-sm">
              <span className="w-1.5 h-1.5 rounded-full bg-violet-400 animate-pulse"></span>
              Next-Gen Crypto Payments
            </div>

            <h1 className="text-2xl sm:text-4xl lg:text-6xl font-black text-white leading-snug tracking-tight mb-2">
              The Future of{' '}
              <span className="block bg-gradient-to-r from-violet-400 via-indigo-400 to-cyan-400 bg-clip-text text-transparent">
                Digital Money
              </span>{' '}
              is Here
            </h1>

            <p className="text-gray-400 text-sm sm:text-base lg:text-lg leading-relaxed mb-8 max-w-lg lg:mx-0">
              Send, spend, buy, and sell crypto with zero friction. Lightning-fast transactions,
              bank-grade security, and a wallet built for the modern world.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-10">
              <Link
                to="/login"
                className="group bg-violet-600 hover:bg-violet-500 text-white font-bold text-xs px-6 sm:px-8 py-3 sm:py-4 rounded-2xl transition-all duration-300 hover:shadow-xl hover:shadow-violet-500/30 hover:-translate-y-0.5 text-center"
              >
                Start Trading Free
                <span className="ml-2 inline-block transition-transform group-hover:translate-x-1">→</span>
              </Link>
              <a
                href="#"
                className="group border border-white/10 hover:border-violet-500/50 text-xs text-white font-semibold px-6 sm:px-8 py-3 sm:py-4 rounded-2xl transition-all duration-300 hover:bg-white/5 backdrop-blur-sm text-center"
              >
                Watch Demo
                <span className="ml-2">▶</span>
              </a>
            </div>
          </div>

          {/* Right Visual */}
          <div className="flex-1 flex justify-center relative mt-12 lg:mt-0">
            <div className="relative">
              <div className="absolute -inset-6 rounded-3xl bg-gradient-to-r from-violet-600/20 to-indigo-600/20 blur-2xl"></div>
              <div className="relative bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-3 shadow-2xl">
                <img src={gif} alt="Ellipticline Platform" className="w-full max-w-sm sm:max-w-md rounded-2xl" />
              </div>
              <div className="absolute -top-3 -right-3 bg-gradient-to-r from-violet-600 to-indigo-600 text-white text-xs sm:text-sm font-bold px-3 py-1.5 rounded-xl shadow-lg shadow-violet-500/30">
                ✓ Bank-grade Security
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;